import accountService from '../../../services/account';

export default {
  data() {
    return {
      loading: true,
      events: [],
      limit: 50,
      currentPage: 0,
      lastPage: '',
      clipboard: '',
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
  },
  async mounted() {
    await accountService.fetchEvents(this, this.limit, this.currentPage);

    if (this.clipboard) {
      this.clipboard.destroy();
    }

    this.clipboard = new Clipboard('.btn8');
    this.clipboard.on('success', (e) => {
      toastr.success(this.$t('account.settings.user_events_section.response_copied'));
      e.clearSelection();
    });

    this.clipboard.on('error', (e) => {
      toastr.error(this.$t('account.settings.user_events_section.error_copy'));
      e.clearSelection();
    });
  },
  methods: {
    async prevPage() {
      if (this.currentPage <= 0) {
        return false;
      }
      if (this.currentPage > 0) {
        this.currentPage -= 1;
        this.loading = true;
        await accountService.fetchEvents(this, this.limit, this.currentPage);
        this.loading = false;
      }
    },
    async nextPage() {
      if (this.lastPage <= this.limit) {
        return false;
      }
      this.currentPage += 1;
      this.loading = true;
      await accountService.fetchEvents(this, this.limit, this.currentPage);
      this.loading = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/account/events/events.js